import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { push } from 'react-router-redux';
import { compose } from 'utils/react';
import { getFlipper } from 'web/store/modules/company';
import { Icon } from 'components';
import SectionLoader from 'components/SectionLoader';
import Authorization from 'containers/Authorization';
import { BUILDER } from 'shared/abilities';
import { FLIPPER_VOYAGER_HEADER_FOOTER_SETS } from '../../../../../../constants/flippers';
import classes from './LayoutSectionLoader.scss';

class LayoutSectionLoader extends React.Component {
  static propTypes = {
    pushRoute: PropTypes.func.isRequired,
    layoutUrl: PropTypes.string,
    localLayoutsEnabled: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  };

  handleDoubleClick = () => {
    const { pushRoute, layoutUrl, disabled } = this.props;
    if (disabled) return;

    pushRoute(layoutUrl);
  };

  render() {
    const { pushRoute, localLayoutsEnabled, ...props } = this.props;

    const icon = localLayoutsEnabled ? 'local' : 'global';
    const text = localLayoutsEnabled ? 'a layout' : 'the global layout';

    return (
      <div className={cx(classes.container, props.type.includes('Footer') && classes.footer)}>
        <SectionLoader {...props} />
        <Authorization action="manage" subject={BUILDER}>
          {authorized => (
            authorized ?
              <div className={classes.overlay} onDoubleClick={this.handleDoubleClick}>
                <div className={classes.description}>
                  <Icon icon={icon} />
                  {' '}
                  {`This item is part of ${text}. Double click to edit this layout.`}
                </div>
              </div>
              :
              <div className={cx(classes.overlay, classes.unauthorized)}>
                <div className={classes.description}>
                  {`This item is part of ${text} which you do not have permission
                  to edit. Please contact support.`}
                </div>
              </div>
          )}
        </Authorization>
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({ localLayoutsEnabled: getFlipper(state, FLIPPER_VOYAGER_HEADER_FOOTER_SETS) }),
    { pushRoute: push },
  ),
)(LayoutSectionLoader);
